import { isEmpty } from 'lodash/fp';

export default function FlashfloodData(currentMode, currentArea, datas, dataTime, thailandJson) {
  // eslint-disable-next-line no-unneeded-ternary
  const modeProvince = (currentMode === 'province' && currentArea.code > 0) ? true : false;

  const getProvinceCodeOrName = (prov) => {
    if (!isEmpty(thailandJson)) {
      return thailandJson.features
        .filter((d) => d.properties.prov_code === prov || d.properties.title === prov)
        // eslint-disable-next-line max-len
        .map((m) => ((m.properties.title === prov) ? m.properties.prov_code : m.properties.title)).toString();
    }
    return null;
  };

  const dataTable = datas.filter((d) => (modeProvince ? (getProvinceCodeOrName(d[0].replace('จ.', '')) === currentArea.code) : d)).map((row) => ({
    province_name: row[1].replace('จ.', ''),
    amphoe_name: row[2],
    tambon_name: row[3],
    ffpi: row[4],
    rainforcast_1d: row[5],
    station_name: row[6],
    basin_name: row[7],
    tambon_code: row[0],
  }));

  // eslint-disable-next-line max-len
  const groupData = [...new Set(dataTable.map((d) => (modeProvince ? d.amphoe_name : d.province_name)))].filter(Boolean);

  const countList = groupData.length;

  return ({
    count: countList,
    list: groupData,
    dataTable,
    dataTime,
  });
}
